import actions from '../store/actions';
import store from '../store/store';
import identityStorage from '../infrastructure/authorization/identityStorage';
import SessionExpireState from './Common/SessionExpire/SessionExpireState';
import messageHelper from './Common/Message/MessageHelper';
import React from 'react';

const setupKeyDown = (): (() => void) => {

    const event = 'keydown';
    const handler = (e: KeyboardEvent): void => {

        if (e.key === 'Escape') {

            store.dispatch({ type: actions.common.closeModal, payload: null as any });
        }
    };

    window.addEventListener(event, handler);

    return () => {
        window.removeEventListener(event, handler);
    };
};

const getContent = (message: string): JSX.Element => {

    if (!message) {
        messageHelper.showMesage('The session expired. Please Log in.');
        return <></>;
    }

    return <div>
        <p>{message}</p>
        <button type='button' className='bg-white btn cn-btn' onClick={() => {
            let isSuccessfull = identityStorage.tryIncreaseSessionExpireTime();

            if (!isSuccessfull) {
                messageHelper.showMesage('The session expired. Please Log in.')
            }
        }
        }>Ok</button>
    </div>
};

const showMesage = (message: string, closeAfter: number): void => {

    var content = getContent(message);

    messageHelper.showMesageAsContent(content, false, false, closeAfter);
}

const sessionExpireCheck = () => {

    const oneMinuteInMileseconds = 60000;
    const minutesRequired = 5;
    const minutesRequiredForWarningDisplay = minutesRequired * oneMinuteInMileseconds;

    const onCheckIfExpireInFiveMinutes = () => {

        let identity = identityStorage.get();

        const minutesUntilSessionExpire = new Date(identity.expirationTimestampIso).getTime() - new Date(new Date().toISOString()).getTime();

        if (minutesUntilSessionExpire <= minutesRequiredForWarningDisplay) {

            const timeLeft = Math.round(minutesUntilSessionExpire / oneMinuteInMileseconds);

            if (timeLeft < 0) {
                messageHelper.showMesage('Your session has expired.');
            }
            else {

                var closeAfter = minutesUntilSessionExpire * 60000;

                showMesage(`Please save your changes. Your session will expire in ${timeLeft} minutes. Click Ok button to increase your session time.`, closeAfter);
            }

            store.dispatch({ type: actions.sessionExpire.warningShowned, payload: { warningShowned: true } as SessionExpireState });

            const intervalId = store.getState().sessionExpireState.intervalId;

            window.clearInterval(intervalId);
        }
    }

    const state = store.getState();

    if (!state.sessionExpireState.intervalId && !state.sessionExpireState.warningShowned) {

        const intervalId = setInterval(onCheckIfExpireInFiveMinutes, oneMinuteInMileseconds);

        store.dispatch({ type: actions.sessionExpire.intervalId, payload: { intervalId } });
    }
}

export { setupKeyDown, sessionExpireCheck, showMesage };